import { YesNoBoth } from '../../webapi/Filter/YesNoBoth';
import { FilterCommonFormValue } from '../../filter';
import { GuidStrValue } from '../../../helpers';

export interface TrackPatientResultFilterFormValue {
    Status: GuidStrValue[] | null;
    Laboratory: GuidStrValue[] | null;
    Results: GuidStrValue[] | null;
    AccessionNumber: string | null;
    Patient: GuidStrValue[] | null;
    PatientCity: string | null;
    PatientState: string | null;
    PatientZip: string | null;
    Urgency: GuidStrValue[] | null;
    Template: GuidStrValue[] | null;
    AttachmentType: GuidStrValue[] | null;
    OrderDate: GuidStrValue | null;
    DueDate: GuidStrValue | null;
    ResultDate: GuidStrValue | null;
    Provider: GuidStrValue[] | null;
    ReferringProvider: GuidStrValue[] | null;
    ServiceSite: GuidStrValue[] | null;
    Procedure: GuidStrValue[] | null;
    PSC: YesNoBoth | null;
    FutureOrders: YesNoBoth | null;
    MaximumItemsReturned: number | null;
    IncludeStrikeouts: boolean | null;
};

export interface TrackPatientResultsFilterFormValue {
  details: TrackPatientResultFilterFormValue;
  common: FilterCommonFormValue;
};
